import { gql } from "lib/apolloClient";

export const dpExamRegFragment = {
  ibisUserBasicDetailsFragment: gql`
    fragment ibisUserBasicDetails on ExamRegistrationStudent {
      id
      firstName
      lastName
      email
      gender
      dob
      category
      isLocked
      subjectsApprovalStatus
      subjectsApprovedAt
      subjectsApprovedBy {
        id
        type
        firstName
        middleName
        lastName
        ... on Student {
          prefix
          suffix
          preferredName
          pronouns
        }
        ... on Staff {
          prefix
          suffix
          preferredName
          pronouns
        }
      }
      isSubjectsApprovalNotificationSent
      subjectsApprovalNotificationSentBy {
        id
        firstName
        middleName
        lastName
        ... on Staff {
          prefix
          suffix
          preferredName
          pronouns
        }
      }
      basicDetailsApprovalStatus
      basicDetailsApprovedAt
      basicDetailsApprovedBy {
        id
        type
        firstName
        middleName
        lastName
        ... on Student {
          prefix
          suffix
          preferredName
          pronouns
        }
        ... on Staff {
          prefix
          suffix
          preferredName
          pronouns
        }
      }
      isBasicDetailsApprovalNotificationSent
      basicDetailsApprovalNotificationSentBy {
        id
        firstName
        middleName
        lastName
        ... on Staff {
          prefix
          suffix
          preferredName
          pronouns
        }
      }
      isSubjectsApproved
      isBasicDetailsApproved
      sessionNumber
      pin
      personalCode
      primaryNationality
      secondaryNationality
      languages
      isAnticipated
      ibisRegistrationStatus
      registrationValidation {
        canRetryRegistration
        validationIssues {
          code
          message
          type
          isCritical
          locale {
            key
            value
          }
        }
      }
      registrationSession {
        id
        session
        month
        year
      }
      anticipatedSessionRegistrationDetails {
        id
        session
      }
      student {
        id
        sourceId
      }
      isExcluded
      registrationDate
      registrationData
    }
  `,
  ibisUserSubjectFragment: gql`
    fragment ibisUserSubjects on ExamRegistrationUserSubjects {
      id
      isAnticipated
      isAdditionalSubject
      subject {
        id
        name
        type
      }
      subjectGroup {
        id
        name
        type
        displaySequence
      }
      level {
        id
        label
      }
      language {
        id
        label
      }
      session {
        id
        session
      }
      wsTheme {
        id
        label
      }
    }
  `,
};

export const ibisExamRegStudentFragment = gql`
  fragment ibisExamRegStudent on ExamRegistrationStudent {
    ...ibisUserBasicDetails
    ibisSubjects(filters: $subjectFilters) {
      ...ibisUserSubjects
    }
  }
  ${dpExamRegFragment.ibisUserBasicDetailsFragment}
  ${dpExamRegFragment.ibisUserSubjectFragment}
`;
